/*SYSTEM IMPORTS*/
import React, { memo, useCallback, useEffect, useState } from "react"

/*API*/
import { Request } from "api";
import DoctorLandingDataAPI from "api/doctor_landing_data"

/*CORE*/
import AppCore from 'cores/AppCore'

/*VIEW*/
import Content from "./Content"
import MainLayout from "containers/LandingLayout/MainLayout"
import { useTitle } from "react-use"

/*HELPERS*/
import {useStore} from "helpers/Utils"

const defParams = {
    allow_video_consultation: false,
    allow_chat_consultation: false,
    has_moderator: false,
    user: null,
    menu: [],
}

const Main = memo(({match}) => {
    const [params, setParams] = useState(defParams)
    const [content, setContent] = useState(null)
    const [init, setInit] = useState(false)

    // const seoTitle = useStore(AppCore.store, "settings.seo.mainpage.title", null)
    /*const seoTitle = AppCore.Settings.getParam("seo.mainpage.title", null)*/

    useTitle(params.user?.seo_title || "promo_doctor_landing")

    const getData = useCallback( async (id) => {
        const {data = {}, settings} = await Request( DoctorLandingDataAPI.getById, { id } )

        const {content, ...params} = data


        AppCore.Settings.Set(settings)
        setContent(content)
        setParams(params)

        setInit(true)
    }, [] )

    useEffect( () => {
        const { id = "" } = match.params
        if (id) {
            getData(id)
        }
    }, [match] )
    
    if (!init) return null

    return (
        <div className="page">
            <MainLayout params={params}>
                <Content
                    content={content}
                    params={params}
                />
            </MainLayout>
        </div>
    )
})

export default Main